import { Injectable } from '@angular/core';
import { PricingService } from './pricing.service';
import { ShipmentService } from './shipment.service';
import { BookMerge, CartStorage } from '@shared/services/cart-storage.service';
import { of } from 'rxjs';

export interface PayPalInfo {
  amount: PayPalAmount;
  items: PayPalItems[];
}
export interface PayPalAmount {
  currency_code: string;
  value: string;
}
export interface PayPalItems {
  name: string;
  quantity: string;
  category: string;
  sku: string;                    // bookcode
  unit_amount: PayPalAmount;
}

@Injectable({
  providedIn: 'root'
})
export class PayPalService {

  constructor(
    private pricingService: PricingService,
    private shipmentService: ShipmentService,
  ) {}


  async buildPaymentInfo(books: BookMerge[], typePurchase: string): Promise<PayPalInfo> {

    // Calculamos costo total de las obras
    let total = 0;
    const currency = this.pricingService.getCurrencyPayPal();
    books.forEach((b: BookMerge) => {
      if (typePurchase == 'physical')
        total += this.pricingService.getWebPricing(b.bookInfo, true) * b.cartInfo.count;
      else if (typePurchase == 'digital')
        total += this.pricingService.getAVPricing(b.bookInfo, true) * b.cartInfo.count;
    });


    const items: PayPalItems[] = [];

    // Agregamos el costo de envío
    if (typePurchase == 'physical') {
      const shipment = await this.shipmentService.getShipmentPayPal();
      items.push({
        name: 'Costo de envío',
        quantity: '1',
        category: 'PHYSICAL_GOODS',
        sku: 'SHIPMENT',
        unit_amount: {
          currency_code: currency,
          value: shipment.toString(),
        }
      });

      total = total + shipment;
    }


    const amountTotal: PayPalAmount = {
      currency_code: currency,
      value: total.toString(),
    };


    // Construimos la información de cada item
    books.forEach((b: BookMerge) => {
      if (typePurchase == 'physical') {
        items.push({
          name: b.bookInfo.title,
          quantity: b.cartInfo.count.toString(),
          category: 'PHYSICAL_GOODS',
          sku: b.bookInfo.bookcode,
          unit_amount: {
            currency_code: currency,
            value: (this.pricingService.getWebPricing(b.bookInfo, true) * 1).toString(),      // El 'quantity' ya nos hace la multiplicación
          }
        });
      } else if (typePurchase == 'digital') {
        items.push({
          name: b.bookInfo.title,
          quantity: b.cartInfo.count.toString(),
          category: 'DIGITAL_GOODS',
          sku: b.bookInfo.bookcode,
          unit_amount: {
            currency_code: currency,
            value: (this.pricingService.getAVPricing(b.bookInfo, true) * 1).toString(),       // Idem
          }
        });
      }
    });

    return {
      amount: amountTotal,
      items: items,
    }
  }

}
